import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  getExplorerMessagingLimitReachedMessage,
  getExplorerMessagingWeeklyResetLabel,
} from "../../utils/explorerMessagingLimitCopy";

type Props = {
  show: boolean;
  onHide: () => void;
  weekResetsUtc?: string;
  used?: number;
  limit?: number;
};

/** Hard paywall when an Explorer exhausts the weekly messaging budget. */
export function ExplorerMessagingLimitModal({
  show,
  onHide,
  weekResetsUtc,
  used = 5,
  limit = 5,
}: Props) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const locale = i18n.resolvedLanguage ?? i18n.language;

  const message = getExplorerMessagingLimitReachedMessage(t, locale, {
    weekResetsUtc,
    used,
    limit,
  });
  const resetLabel = getExplorerMessagingWeeklyResetLabel(t, locale, weekResetsUtc);

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      aria-labelledby="explorer-messaging-limit-title"
      className="explorer-limit-paywall-modal"
      backdropClassName="explorer-limit-paywall-backdrop"
    >
      <Modal.Header closeButton>
        <Modal.Title id="explorer-messaging-limit-title">
          {t("messages.explorerWeeklyLimitTitle")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3 fw-medium">{message}</p>
        <p className="mb-0 small text-secondary">{resetLabel}</p>
      </Modal.Body>
      <Modal.Footer className="flex-column flex-sm-row gap-2 border-0 pt-0">
        <Button variant="outline-secondary" className="w-100 w-sm-auto" onClick={onHide}>
          {t("messages.explorerWeeklyLimitDismiss")}
        </Button>
        <Button
          variant="primary"
          className="w-100 w-sm-auto"
          onClick={() => {
            onHide();
            navigate("/members-benefits-smbf");
          }}
        >
          {t("messages.explorerWeeklyLimitUpgrade")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
